import ReactPlayer from 'react-player'
import {baseURL, LEHGU_LOGO_URL, erfahrenSieMehrPageID, jwtName} from "../constants"
import Footer from "./Footer"

export default function ErfahrenSieMehr(){

    return (
        <div className='staticNormalPage'>
        <div className="partialContainer ">
            <h2 className="">
            Stimmliche und mentale Gesundheit für Lehrkräfte
            </h2>

            <div className="flex ">
                <img
                className="loginLogo "
                src={LEHGU_LOGO_URL}
                alt=""
                />
            </div>

            <div className="lehguParagraph ">
                Das Freiburger Institut für Musikermedizin (FIM – Universität und Universitätsklinikum Freiburg) bietet <strong>ab Dienstag, 08. April 2025</strong> wieder die 
                <strong> Blended-Learning-Fortbildung LEHGU&nbsp;</strong> (<strong>Leh</strong>rer*innen<strong>g</strong>es<strong>u</strong>ndheit) zur stimmlichen und mentalen Gesundheit von Lehrkräften aller Schularten in Baden-Württemberg an.<br />
                <br />

                Zahlreiche Studien belegen die Relevanz des Themas und zeigen im Lehrkraftberuf ein erhöhtes Risiko zur Entwicklung von Stimmproblemen und mentalen Belastungen, die eng miteinander verbunden sind. Das Fortbildungsangebot nimmt daher sowohl die stimmliche als auch die mentale Gesundheit in den Fokus und berücksichtigt ebenso deren Wechselwirkung im pädagogischen Alltag.                <br />
                <br />

                <p>&nbsp; &nbsp;• „Was hilft mir, in meinem Beruf gesund zu bleiben?“ </p>
                <p>&nbsp; &nbsp;• „Wie kann ich stimmschonend unterrichten?“ </p>
                <p>&nbsp; &nbsp;• „Wie kann ich Stress im Schulalltag begegnen?“ </p>

                Diese und viele weitere Fragen werden in der Fortbildung thematisiert.                 
                <br /><br />

                LEHGU sieht <strong>acht digitale e-Learning-Einheiten</strong> (asynchron) und <strong>drei begleitende Veranstaltungen</strong> (synchron, davon eine digital als Kick-Off und zwei Präsenzworkshops) 
                sowie <strong>eine optionale Stimmuntersuchung mit individueller Rückmeldung</strong> (inkl. Kehlkopfspiegelung, Stimmfeldmessung und auditiver Beurteilung) vor. 
                Die Inhalte des e-Learnings stehen als browserbasierte Anwendung für den PC sowie als eigenständige App für Tablet oder Smartphone zur Verfügung.<br />
                Außerdem besteht die Möglichkeit, eine <strong>optionale Stimmuntersuchung</strong> mit individueller Rückmeldung und/oder <strong>individuelle Beratung zu psychischen Belastungen</strong> zu erhalten.
                Bei Bedarf zur Diagnostik von stimmlichen Beschwerden und zur Beratung zu psychischen Belastungen melden Sie sich bitte zur Terminvereinbarung unter: <br />

                <a href="mailto:fim.lehrkraefteambulanz@uniklinik-freiburg.de">fim.lehrkraefteambulanz@uniklinik-freiburg.de</a>.
            
            </div>

            <div className="lehguParagraph ">
                <div className="videoPLayer">
                    <ReactPlayer url={"https://lehgu.de/videos/LEHGU_Demovideo_16-04-2024.mp4"} controls={true} />
                </div>
            </div>

            <div className="lehguParagraph ">
                <p><br />
                Die Fortbildung wird vom Freiburger Institut für Musikermedizin (FIM) unter Verwendung von Fragebogenerhebungen wissenschaftlich begleitet und evaluiert.<br />
                <br />
                <p>Bitte melden Sie sich bei Interesse an der LEHGU Fortbildung bis <strong>Montag, 31. März 2025</strong> über
                folgenden Link an: <a style={{color: "blue"}} href="https://terminplaner6.dfn.de/de/b/fd1ab92ed2354675c258f68b5d22223e-825643" target="_blank" >
                https://terminplaner6.dfn.de/de/b/fd1ab92ed2354675c258f68b5d22223e-825643</a>.
                Geben Sie dort bitte Ihren <strong>Namen</strong> und Ihre <strong>E-Mail-Adresse</strong> für eine verbindliche Anmeldung an und
                wählen Sie eine für Sie passende <strong>Terminkombination für die beiden Workshops</strong> (siehe unten) aus. Die
                Workshops werden am Institut für Musikermedizin in Freiburg stattfinden. </p>

                <br />
            
                Sofern Sie die Fortbildung als Arbeitszeit angerechnet haben möchten, denken Sie bitte daran, die Genehmigung Ihrer Schulleitung einzuholen, um eine Freistellung vom Unterricht sowie Ihren Versicherungsschutz zu gewährleisten. Am Ende der Fortbildung erhalten Sie eine Teilnahmebestätigung vom Freiburger Institut für Musikermedizin.                 <br />
                &nbsp;</p>
                <p>&nbsp;</p>
                <p><u>Im Folgenden finden Sie alle wichtigen Termine aufgelistet:</u></p>
                <p><strong>&nbsp;<br />
                Synchrone Kick-Off-Veranstaltung (digital)</strong></p>
                <p>&nbsp; &nbsp;• Dienstag, <em>08. April 2025</em>, 15 - 16 Uhr</p>
                <p>&nbsp;<br />
                <strong>Präsenzworkshop I &amp; II am:</strong></p>
                <p>&nbsp; &nbsp;• Dienstag, 29.04.25 und Montag, 23.06.25 jeweils 14:00 - 17:00 Uhr</p>
                <p>&nbsp; &nbsp;• Mittwoch, 30.04.25 und Dienstag, 24.06.25 jeweils 9:30 - 12:30 Uhr </p>
                
                &nbsp;<br />
                <p><strong>Bei Bedarf zur Diagnostik von stimmlichen Beschwerden und zur Beratung zu psychischen Belastungen melden Sie sich bitte zur Terminvereinbarung unter:</strong> <br />
                <a href="mailto:fim.lehrkraefteambulanz@uniklinik-freiburg.de">fim.lehrkraefteambulanz@uniklinik-freiburg.de</a>
                </p>















                <p>&nbsp;<br />
                <strong>Asynchrone Bearbeitung der e-Learning Einheiten</strong></p>
                <p>&nbsp; &nbsp;• Ab <em>08. April 2025</em> <br />
                &nbsp;</p>

                
                <p>Die Datenschutzerklärung der Fortbildung sowie die Datenschutzerklärung zur LEHGU-Evaluation finden Sie hier: </p>
                <p>&nbsp; &nbsp;• Datenschutzerklärung der LEHGU-Fortbildung <a href="https://lehgu.de/prof_cms/fileadmin/lehgu/files/Datenschutzerklärung der LEHGU-Fortbildung 2025.pdf" target="_blank">(Link PDF)</a></p>
                <p>&nbsp; &nbsp;• Datenschutzerklärung der LEHGU-Evaluation <a href="https://lehgu.de/prof_cms/fileadmin/lehgu/files/Datenschutzerklärung der LEHGU-Evaluation 2025.pdf" target="_blank">(Link PDF)</a></p>
                
                <p>Für Fragen steht Ihnen das LEHGU-Team im Freiburger Institut für Musikermedizin (FIM) unter der Projektleitung von Dr. Nico Hutter, Prof. Dr. Dr. Claudia Spahn und Prof. Dr. Bernhard Richter zur Verfügung: <a href="mailto:info@lehgu.de">info@lehgu.de</a>.</p>
            </div>

            

        </div>
        <Footer /> 
        </div>
    )


    {  
               //  Bitte melden Sie sich bei Interesse an der LEHGU Fortbildung bis <strong>Montag, 04. März 2024 </strong>über folgenden Link an: 
              //  <a href="https://terminplaner6.dfn.de/b/56cfd97ce7dceb470b5c47d97f61c3aa-520639">https://terminplaner6.dfn.de/b/56cfd97ce7dceb470b5c47d97f61c3aa-520639</a>. Geben Sie dort bitte Ihren <strong>Namen</strong> und Ihre <strong>E-Mail-Adresse</strong> für eine verbindliche Anmeldung an und wählen Sie eine für Sie passende <strong>Terminkombination für die beiden Workshops</strong> (siehe unten) aus. Die Workshops werden am Institut für Musikermedizin in Freiburg stattfinden.<br />
               // <br />
                }



}







                